import { Button, ModalWindow } from "@tblabs/truffle";
import { PasswordSanitizer } from "../Utils/PasswordSanitizer";
import { Device } from "../Services/Device";


export class AdminWatchWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`🐓 ${device.Id} Admin watch`, true, true, true);

        this.content.Append(
            new Button("LOCAL").Class("uk-button uk-button-default")
                .OnClick(async () => this.OpenWatcherPage(device, process.env.WATCHER_LOGIN_PAGE__LOCAL)),
            new Button("STAGE").Class("uk-button uk-button-primary")
                .OnClick(async () => this.OpenWatcherPage(device, process.env.WATCHER_LOGIN_PAGE__STAGE)),
            new Button("PROD").Class("uk-button uk-button-danger")
                .OnClick(async () => this.OpenWatcherPage(device, process.env.WATCHER_LOGIN_PAGE__PROD)),
        );

        this.OpenWindow();
    }

    private OpenWatcherPage(device: Device, watcherUrlTemplate: string)
    {
        if (!device.Password.value) 
        {
            alert("Set password first!")
            return;
        }

        const password = PasswordSanitizer.Sanitize(device.Password.value);

        const adminToken = window.localStorage.getItem("admin-watcher-token");

        const watcherUrl = watcherUrlTemplate
            .replace("{server}", device.ServerId)
            .replace("{password}", password)
            .replace("{adminToken}", adminToken);

        window.open(watcherUrl);
    }
}
